/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Injectable } from '@angular/core';

@Injectable()
export class ErrorData {

  public storage: any;

  public constructor() { }

}

export class ClientError {
  public Timestamp: Date;
  public mapStack: string;
  public message: string;
  public url: string;
}
